import React, { memo, useState } from 'react';
import { Button, Grid, Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../common/Logo';
import { AppBreadcrumb } from './AppBreadcrumb';
import { UserMenu } from './UserMenu';
import { LoginModal } from '../auth/LoginModal';
import { useAuth } from '../../hooks/useAuth';
import './AppHeader.css';

const { Header } = Layout;
const { useBreakpoint } = Grid;

export const AppHeader: React.FC = memo(() => {
  const navigate = useNavigate();
  const { user, isAuthenticated, signOut } = useAuth();
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/', { replace: true });
    }
  };

  const handleEditProfile = () => {
    navigate('/profile');
  };

  return (
    <>
      <Header className="app-header">
        <Logo onClick={() => navigate('/')} compact={isMobile} />

        {isAuthenticated && (
          <div className="app-header-breadcrumb">
            <AppBreadcrumb />
          </div>
        )}

        <div className="app-header-user">
          {isAuthenticated && user ? (
            <UserMenu
              userName={user.username || 'Usuário'}
              userEmail={user.email || ''}
              userRole={user.role}
              onLogout={handleLogout}
              onEditProfile={handleEditProfile}
            />
          ) : (
            <Button type="primary" onClick={() => setLoginModalOpen(true)}>
              Entrar
            </Button>
          )}
        </div>
      </Header>

      <LoginModal open={loginModalOpen} onClose={() => setLoginModalOpen(false)} />
    </>
  );
});
